import { ENV } from 'src/utils';

export default {
  SIGN_UP: ENV.appSignUpUrl,

  SUPPORT: 'https://help.catch.co',

  FACEBOOK: 'https://facebook.com/catchbenefits',
  INSTAGRAM: 'https://instagram.com/catchbenefits',
  LINKEDIN: 'https://www.linkedin.com/company/catchbenefits',
  TWITTER: 'https://twitter.com/catchbenefits',

  HEALTHCARE_GOV: 'https://healthcare.gov',
  CUIDADODESALUD_GOV: 'https://www.cuidadodesalud.gov/es/',
  QUALITY_RATINGS: 'https://www.healthcare.gov/quality-ratings/',
  CFR_155_220: 'https://www.ecfr.gov/current/title-45/section-155.220',
  CFR_155_260: 'https://www.ecfr.gov/current/title-45/section-155.260',
};
